import React, {useState} from "react";
import {TreeOutput} from "./TreeOutput/TreeOutput";

export const OrgLimits = (props) => {
    const {limits} = props;

    return (
        <TreeOutput items={limits}/>
    )
}